<template>
  <div class="app-container">
    <list ref="list">
        
    </list>
  </div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";
import list from '@/components/statistics/purchase/list'

export default {
  name: "purchase",
  mixins: [curdMixins],
  components: { list },
  methods: {
    
  }
};
</script>